/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Corporate } from '../../models/corporate';

export interface ApiMasterCorporateGetActiveGet$Params {
}

export function apiMasterCorporateGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterCorporateGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Corporate>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCorporateGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Corporate>>;
    })
  );
}

apiMasterCorporateGetActiveGet.PATH = '/api/Master/Corporate/GetActive';
